import { render, staticRenderFns } from "./DocumentsSign.vue?vue&type=template&id=55fadb56&scoped=true"
import script from "./DocumentsSign.vue?vue&type=script&lang=js"
export * from "./DocumentsSign.vue?vue&type=script&lang=js"
import style0 from "./DocumentsSign.vue?vue&type=style&index=0&id=55fadb56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fadb56",
  null
  
)

export default component.exports